import { inviteTokenInPath } from '@/domain/invites'
import { createApiClient } from './client'

/// The gateway, baked in at build time (Dockerfile ARG VITE_API_URL). Locally
/// the gateway runs on :4000.
export const API_URL: string = import.meta.env['VITE_API_URL'] ?? 'http://localhost:4000'

const safeStorage: Pick<Storage, 'getItem' | 'setItem' | 'removeItem'> = {
  getItem: (key) => {
    try {
      return localStorage.getItem(key)
    } catch {
      return null
    }
  },
  setItem: (key, value) => {
    try {
      localStorage.setItem(key, value)
    } catch {
      // Private mode or blocked storage: the session lasts this tab only.
    }
  },
  removeItem: (key) => {
    try {
      localStorage.removeItem(key)
    } catch {
      // nothing to remove
    }
  },
}

/// A full page load, not a router navigation: it also throws away every
/// cached query — none of it belongs to whoever signs in next. From an
/// invitation, sign-in brings the person back to it.
const goToSignIn = (): void => {
  const { pathname } = window.location
  if (pathname.startsWith('/sign-in')) return
  const invite = inviteTokenInPath(pathname)
  window.location.assign(invite ? `/sign-in?invite=${invite}` : '/sign-in')
}

export const api = createApiClient({
  baseUrl: API_URL,
  fetch: (...args) => fetch(...args),
  storage: safeStorage,
  onSessionEnded: goToSignIn,
})
